import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import ListMainWrapper from '../../../common/listMainWrapper';
import Row from './row';
import Loader from './loader';
import AuthenticationProviderType from '../../../../services/enums/authenticationProviderType';

@inject('translationsStore', 'directoryUserMappingStore') @observer
export default class DirectoryUsersListContainer extends Component {

    directoryUserMappingStore = this.props.directoryUserMappingStore;

    rowRenderer = ({key, index, isScrolling, isVisible, style}) => {
        
        let item = this.props.directoryUserMappingStore.usersEntries[index];
        
        return(
            <Row
                key={item.username}
                dataKey={item.username}
                user={item}
                translations={{                                   
                    import: this.props.translationsStore.translate('IMPORT')
                }}
                onClick={this.props.importUser}
                style={style}
            />
        )
    }

    render() {

        const users = this.props.directoryUserMappingStore.usersEntries;

        const searchIconTranslation = this.directoryUserMappingStore.selectedProviderType.toLowerCase() === AuthenticationProviderType.LDAP.toLowerCase()
                ? this.props.translationsStore.translate('SEARCH_ICON_TO_SEARCH_THE_LDAP_USERS') 
                : this.props.translationsStore.translate('SEARCH_ICON_TO_SEARCH_THE_DOMAIN_USERS');

        return (
            <div>
                {
                    this.directoryUserMappingStore.getUserEntriesProgress ? 
                        <Loader /> 
                        :   
                        <ListMainWrapper
                            items={users}
                            translations={{                                   
                                title1: this.props.translationsStore.translate('USER_NAME'),
                                title2: this.props.translationsStore.translate('EMAIL'),
                                noEntries: this.props.translationsStore.translate('NO_USER_ENTRIES'),
                                searchIconToSearchUsers: searchIconTranslation
                            }}
                            rowHeight={40}
                            rowRenderer={this.rowRenderer}
                        />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/users/directoryUsers/usersList/index.jsx